import { Bot, Loader2Icon, RefreshCw, User } from 'lucide-react'
import React, { FC, useState } from 'react'
import { AppInfoStore, ConfigStore } from '@/shared/model/store'
import { Avatar, AvatarFallback, AvatarImage } from '@/shared/ui'
import defaultAvatar from '@/shared/assets/images/avatar-default.svg'
import { UserName } from '@/shared/ui/user-name'
import { IUser } from '../model/types'
import { Link } from 'react-router-dom'
import { cn } from '@/shared/lib'

type Props = {
	user: IUser | null
	descriprion?: string | React.ReactNode
	length?: number
	onlyAvatar?: boolean
	forTrigger?: boolean
	className?: string
	onClick?: (data?: any) => void
}

export const getUserProfileLink = (user: IUser | null | undefined) =>
	user ? (user.name ? `/@${user.name}` : `/${user.address}`) : ''

export const UserCard: FC<Props> = ({ user, descriprion, length, onlyAvatar, forTrigger, className, onClick }) => {
	const {
		appInfo: { ipfs_gateways }
	} = AppInfoStore()
	const [imgLoading, setImgLoading] = useState<boolean>(false)
	const link = getUserProfileLink(user)

	if (forTrigger) {
		return (
			<div>
				<Avatar className={cn('bg-secondary', className)}>
					<AvatarImage
						onLoad={() => setImgLoading(false)}
						src={user?.avatar ? `${ipfs_gateways[0]}${user.avatar}` : defaultAvatar}
						alt='name'
					/>
					<AvatarFallback>
						{user?.avatar === 'system' ? (
							<Bot />
						) : imgLoading ? (
							<RefreshCw className='h-4 w-4 animate-spin' />
						) : (
							<User />
						)}
					</AvatarFallback>
				</Avatar>
			</div>
		)
	}

	return (
		<Link className='relative flex items-center gap-1' to={link} onClick={onClick && onClick}>
			<Avatar className={cn('relative', className)}>
				<AvatarImage
					src={user?.avatar ? `${ipfs_gateways[0]}${user.avatar}` : defaultAvatar}
					alt='name'
					onLoad={() => setImgLoading(false)}
				/>
				<AvatarFallback>
					{user?.avatar === 'system' ? <Bot /> : imgLoading ? <RefreshCw className='h-4 w-4 animate-spin' /> : <User />}
				</AvatarFallback>
			</Avatar>
			{/* {user?.is_npo && (
				<span className='absolute -bottom-1 left-0 rounded-full bg-accent px-1 py-1 text-[8px]'>NPO</span>
			)} */}
			{!onlyAvatar && (
				<div className='ml-3 flex h-full flex-col justify-evenly'>
					<UserName account={user ?? ({} as IUser)} sliceLen={length} />
					<div>
						<p className='text-sm text-muted-foreground'>{descriprion}</p>
					</div>
				</div>
			)}
		</Link>
	)
}
